import React from 'react';
import moment from 'moment';
import { Col } from 'antd';
import FormRow from '../../../../common/formComponents/FormRow/FormRow';
import TimePickerField from '../../../../common/formComponents/TimePickerField/TimePickerField';
import {
  fieldNames,
  timePickerProps,
  HOUR_INTERVAL_ID,
  defaultDate,
} from '../constants';

const TimeFieldsRow = ({ form, checkMinutesMatchInterval }) => {
  const { getFieldError, getFieldValue, validateFields } = form;

  const validateFromStartTime = (_rule, value, callback) => {
    if (value) {
      validateFields(
        [
          fieldNames.endTime,
          fieldNames.lunchStartTime,
          fieldNames.lunchEndTime,
        ],
        { force: true }
      );
    }

    callback();
  };

  const validateFromEndTime = (_rule, value, callback) => {
    const startTimeErr = getFieldError(fieldNames.startTime);
    const lunchStartTime = getFieldValue(fieldNames.lunchStartTime);
    const lunchEndTime = getFieldValue(fieldNames.lunchEndTime);

    if (value) {
      if (startTimeErr) {
        validateFields([fieldNames.startTime], { force: true });
      }

      if (lunchStartTime) {
        validateFields([fieldNames.lunchStartTime], { force: true });
      }

      if (lunchEndTime) {
        validateFields([fieldNames.lunchEndTime], { force: true });
      }
    }

    callback();
  };

  const intervalIdVal = form.getFieldValue(fieldNames.intervalId);

  const minuteStep = intervalIdVal === HOUR_INTERVAL_ID ? 60 : 30;

  const inputProps = {
    ...timePickerProps,
    minuteStep,
  };

  return (
    <FormRow type="flex" gutter={20}>
      <Col span={12}>
        <TimePickerField
          form={form}
          label="Начало рабочего времени"
          name={fieldNames.startTime}
          options={{
            initialValue: moment('09:00', 'HH:mm'),
            rules: [
              {
                type: 'object',
                required: true,
                message: 'Укажите начало рабочего времени',
              },
              {
                validator: checkMinutesMatchInterval,
              },
              {
                validator: validateFromStartTime,
              },
              {
                validator: (_rule, value, callback) => {
                  const endTime = getFieldValue(fieldNames.endTime);

                  if (value && endTime) {
                    const endTimeFormat = endTime.format('HH:mm');
                    const startTimeFormat = value.format('HH:mm');

                    const startDate = moment(
                      `${defaultDate} ${startTimeFormat}`
                    );
                    const endDate = moment(`${defaultDate} ${endTimeFormat}`);

                    if (startDate.isSameOrAfter(endDate)) {
                      return callback(
                        'Начало рабочего времени не может быть выше конца рабочего времени'
                      );
                    }
                  }

                  return callback();
                },
              },
            ],
          }}
          inputProps={inputProps}
        />
      </Col>

      <Col span={12}>
        <TimePickerField
          form={form}
          label="Конец рабочего времени"
          name={fieldNames.endTime}
          options={{
            initialValue: moment(`18:00`, 'HH:mm'),
            rules: [
              {
                type: 'object',
                required: true,
                message: 'Укажите конец рабочего времени',
              },
              {
                validator: checkMinutesMatchInterval,
              },
              {
                validator: validateFromEndTime,
              },
              {
                validator: (_rule, value, callback) => {
                  const startTime = getFieldValue(fieldNames.startTime);

                  if (value) {
                    const startTimeFormat = startTime.format('HH:mm');

                    const endTimeFormat = value.format('HH:mm');

                    const startDate = moment(
                      `${defaultDate} ${startTimeFormat}`
                    );
                    const endDate = moment(`${defaultDate} ${endTimeFormat}`);

                    if (moment(startDate).isSameOrAfter(endDate)) {
                      return callback(
                        'Конец рабочего времени не может быть ниже начала рабочего времени'
                      );
                    }
                  }
                  return callback();
                },
              },
            ],
          }}
          inputProps={inputProps}
        />
      </Col>
    </FormRow>
  );
};

export default TimeFieldsRow;
